export const defaultAttachmentContentStyles = {
  width: "200px"
};